import { FullscreenState, ScreenshotModeState } from "../contexts/MapContextState";

/**
 * Composing a screenshot is two facts about the map: it is presented expanded
 * (layout — menu offsets, toolbar sizing) and it is composing a capture frame.
 * Only the second may suspend the viewport-driven filter, and even then only
 * for quantile bins — see `MapboxWrapper`'s `isExtentSyncFrozen`. The expanded
 * map toggle and the geom-bin panel set `isFullscreen` on their own and must
 * keep filtering.
 *
 * Every screenshot entry point must write the pair through here. Writing
 * `isFullscreen` alone leaves `isScreenshotMode` at whatever it was: on entry the
 * freeze is never established, and on exit it is never released — the viewport
 * stops driving the filter for the rest of the session. `isScreenshotMode` has
 * two readers: the quantile freeze in `MapboxWrapper`, which is silent, and
 * `MapFullscreen`, which withholds Toggle Fullscreen while the flag is true. A
 * stranded flag therefore shows up as that button missing for the rest of the
 * session — the one visible symptom of an exit that skipped this helper.
 */
export const screenshotModePayload = (
  active: boolean
): FullscreenState & ScreenshotModeState => ({
  isFullscreen: active,
  isScreenshotMode: active
});
